var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:'header ' + 
      (_vm.large ? 'large' : '') + 
      (_vm.twoLine ? 'two-line' : ''),style:({'--base-color': _vm.color})},[(_vm.icon)?_c('v-icon',{staticClass:"announcement-icon"},[_vm._v(" "+_vm._s(_vm.icon)+" ")]):_vm._e(),_c('div',{staticClass:"announcement-title"},[_c('p',{staticClass:"announcement-title-text"},[_vm._v(" "+_vm._s(_vm.text)+" ")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }